package br.com.vvrefeicoes.portal.domain.model

data class UserAccount(
    val id: String,
    val fullName: String,
    val role: String,
    val cargo: String = "",
    val companyNames: List<String> = emptyList(),
    val sector: String,
    val phone: String,
    val email: String,
    val profileId: String? = null,
    val permissions: Map<String, Set<PermissionAction>> = emptyMap(),
    val updatedBy: String,
    val updatedAt: String,
    val lastAccess: String,
    val active: Boolean = true,
)
